<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        داشبورد طرف معامله
      </q-banner>
    </q-card-section>
    <q-card-section>
      <ProductSearchResults/>
    </q-card-section>

    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showInsertCustomerDialog">
      <q-card>
        <q-card-section>
          <CUCustomerInfo action="insert" @customer-updated="customerUpdated"/>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import ProductSearchResults from "@/components/products/ProductSearchResults";
import EventBus from "@/event-bus";
import CUCustomerInfo from "@/components/customers/CUCustomerInfo";

export default {
  name: "CustomerDashboard",
  components: {CUCustomerInfo, ProductSearchResults},
  props: {
    customerId: {
      type: String
    }
  },
  data() {
    return {
      selectedCustomer: {},
      showInsertCustomerDialog: false
    }
  },
  methods: {
    ...mapActions({
      getCustomerInfo: 'Customers/get_customer_info'
    }),
    customerUpdated() {
      this.showInsertCustomerDialog = false;
    },
  },
  created() {
    if (this.$route.params.customerId === '-1') {
      this.showInsertCustomerDialog = true
    } else {
      this.getCustomerInfo(this.$route.params.customerId).then((res) => {
        this.selectedCustomer = res.data[0]
        if (this.selectedCustomer.ValidInformation !== 1) {
          this.$q.notify({
            message: 'اطلاعات طرف معامله نادرست است، لطفا ابتدا اطلاعات طرف معامله را اصلاح نموده  و سپس اقدام یه ثبت سفارش نمایید',
            color: 'negative',
            position: 'top',
            type: 'negative',
            multiLine: true
          });
        } else {
          if (this.selectedCustomer.NotAcceptedOrder !== 0) {
            this.$q.notify({
              message: 'طرف معامله دارای سفارش تایید نشده می باشد',
              color: 'deep-orange',
              position: 'top',
              type: 'deep-orange',
              multiLine: true
            });
          }
          EventBus.$emit('invoke-selected-customer', this.selectedCustomer);
          EventBus.$emit('invoke-customer-search-result-event', []);
        }
      })
    }
  }
}
</script>

<style scoped>

</style>